import { useFormik } from 'formik';
import * as Yup from 'yup';

interface useFormikConceptFiltersProps {
  onSubmit: (values: any) => void;
}

const useFormikConceptFilters = ({ onSubmit }: useFormikConceptFiltersProps) => {
  const initialValues = {
    ticket: '',
    status_id: '',
    created_at: '',
    requester_id: '',
  };

  const validationSchema = Yup.object({
    ticket: Yup.string(),
    status_id: Yup.string(),
    created_at: Yup.date().nullable(),
    requester_id: Yup.string(),
  });

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (values, actions) => {
      onSubmit(values);
      actions.setSubmitting(false);
    },
  });

  return formik;
};

export default useFormikConceptFilters;
